import { Box, Flex, Grid, Text } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

import { useAppNav } from '@/hooks/useAppNav.hook';

// Navigation for contest
export const Navigation = () => {
  const { contestNav, isContestNavVisible } = useAppNav();

  if (!isContestNavVisible) {
    return null;
  }

  return (
    <Grid
      color='white'
      gap='5px'
      gridTemplateColumns={`repeat(${contestNav.length}, 1fr)`}
      paddingBlock='24px'
    >
      {contestNav.map((item) => (
        <Box
          as={NavLink}
          {...item?.linkData}
          _first={{ borderTopStartRadius: '8px' }}
          _last={{ borderTopEndRadius: '8px' }}
          bgColor={item.selected ? 'OlybetPrimaryRed' : 'OlybetGrey07'}
          key={item.linkData.to as string}
        >
          <Flex align='center' h='44px' justify='center'>
            <Text lineHeight={1} textAlign='center'>
              {item.label}
            </Text>
          </Flex>
        </Box>
      ))}
    </Grid>
  );
};
